import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';
import { FETCH_PORTFOLIO_OPTIMIZER_RAN_AT } from './portfolioOptimizerBreadcrumb.query';

export const PortfolioOptimizerBreadcrumb = () => {
  const { localizedDateTime } = useLocalization();
  const { id } = useParams();
  const { data } = useQuery(FETCH_PORTFOLIO_OPTIMIZER_RAN_AT, {
    variables: { input: { portfolioOptimizerId: id ?? '' } },
    skip: !id,
  });
  const createdAt =
    data?.fetchPortfolioOptimizer?.portfolioOptimizer?.createdAt;

  return createdAt ? localizedDateTime(createdAt) : '';
};
